import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up-new.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down-new.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-751e29f3")

_pushScopeId("data-v-751e29f3")
const _hoisted_1 = { class: "text-12px text-gray-lp-300 font-semibold" }
const _hoisted_2 = { class: "flex mt-1" }
const _hoisted_3 = { class: "text-16px flex items-center cursor-pointer text-gray-lp-300 font-semibold" }
const _hoisted_4 = { style: {"margin-left":"-14px","margin-right":"-14px","width":"300px"} }
const _hoisted_5 = { class: "border-b border-gray-lp-400 px-4 py-2" }
const _hoisted_6 = { class: "inline-flex justify-between" }
const _hoisted_7 = { class: "font-semibold text-14px text-gray-lp-300" }
const _hoisted_8 = { class: "flex flex-col pb-2 gap-1 p-4 text-14px xxl:text-14px text-black-lp-100" }
const _hoisted_9 = { class: "flex flex-row gap-1" }
const _hoisted_10 = { class: "flex flex-grow" }
const _hoisted_11 = { class: "text-1px text-right" }
const _hoisted_12 = { class: "flex flex-grow" }
const _hoisted_13 = { class: "text-1px text-right" }
const _hoisted_14 = { class: "flex flex-grow" }
const _hoisted_15 = { class: "text-1px text-right" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "px-4" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_17 = { class: "flex flex-row pb-2" }
const _hoisted_18 = { class: "flex flex-grow text-black-lp-100 text-14px xxl:text-14px float-left pl-4 pt-2" }
const _hoisted_19 = { class: "text-black-lp-100 text-1px xxl:text-14px pr-4 float-right text-right pt-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", {
    id: _ctx.id,
    class: "relative flex flex-col py-1 px-2 rounded-lg bg-gray-lp-1000 border border-gray-lp-1400"
  }, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("bookingV3.shipment.chargeableWeight.label")), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.formatNumber(_ctx.chargeableWeight)), 1),
      _withDirectives(_createVNode("button", {
        class: "flex items-center ml-0.5",
        onMousedown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isMouseDown = true)),
        onMouseup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isMouseDown = false)),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleTooltip($event))),
        onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onFocusTrigger($event))),
        onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hideToggle && _ctx.hideToggle(...args))),
        onKeydown: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onKeydownTrigger($event)))
      }, [
        _createVNode("img", {
          alt: "up",
          class: `cursor-pointer w-4 ${_ctx.isShow ? '' : 'hidden'}`,
          src: _imports_0
        }, null, 2),
        _createVNode("img", {
          alt: "down",
          class: `cursor-pointer w-4 ${_ctx.isShow ? 'hidden' : ''}`,
          src: _imports_1
        }, null, 2)
      ], 544), [
        [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
      ])
    ]),
    _createVNode(_component_OverlayPanel, {
      ref: "opTooltipWeightCost",
      appendTo: "body",
      class: "w-auto",
      unstyled: true
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("bookingV3.shipment.chargeableWeight.detail")), 1)
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("bookingV3.shipment.chargeableWeight.totalItem")), 1),
              _createVNode("div", _hoisted_11, _toDisplayString(_ctx.totalItem), 1)
            ]),
            _createVNode("div", {
              class: 
              `flex flex-row gap-1 ${
                _ctx.isGrossWeight && !_ctx.isCampaign
                  ? 'text-black-lp-100'
                  : 'text-gray-lp-600'
              }`
            
            }, [
              _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("bookingV3.shipment.chargeableWeight.totalGrossWeight")), 1),
              _createVNode("div", _hoisted_13, _toDisplayString(_ctx.formatNumber(_ctx.totalGrossWeight)), 1)
            ], 2),
            _createVNode("div", {
              class: 
              `flex flex-row gap-1 text-gray-lp-600 ${
                _ctx.isVolumeWeight && !_ctx.isCampaign
                  ? 'text-black-lp-100'
                  : 'text-gray-lp-600'
              }`
            
            }, [
              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("bookingV3.shipment.chargeableWeight.totalDimensionWeight")), 1),
              _createVNode("div", _hoisted_15, _toDisplayString(_ctx.formatNumber(_ctx.totalDimensionWeight)), 1)
            ], 2)
          ]),
          _hoisted_16,
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("bookingV3.shipment.chargeableWeight.label")), 1),
            _createVNode("div", _hoisted_19, _toDisplayString(_ctx.formatNumber(_ctx.chargeableWeight)), 1)
          ])
        ])
      ]),
      _: 1
    }, 512)
  ], 8, ["id"])), [
    [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
  ])
})